import {
    Component,
    Input,
    OnInit,
    EventEmitter,
    Output,
    OnChanges,
    SimpleChanges,
    OnDestroy, effect} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IdentifierService } from 'merlin-core';
import { ToastrService } from 'ngx-toastr';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { EmergencyContactPopup } from '../../address-and-contact-information/emergency-contact-popup/emergency-contact-popup.component';
import { EnrollPatientDeviceDataService } from '../../../../services/enroll-patient-device-data.service';
import { CountryCdEnum, PopupService } from 'merlin-library';
import { FunctionMode } from '../../../enums/enroll-patient.enum';
import { Subscription } from 'rxjs';
import { CommonService } from 'projects/clinician/src/app/shared/service/common.service';
import { AVEIR_ALL_CODES } from '../../device-transmit-information/device-codes.constants';
@Component({
    selector: 'view-address-contact-information',
    templateUrl: './view-address-and-contact-information.component.html',
    styleUrls: ['./view-address-and-contact-information.component.scss'],
    standalone: false
})
export class ViewAddressContactInformationComponent implements OnInit, OnChanges, OnDestroy {
    private readonly aveirLpCodes = new Set(AVEIR_ALL_CODES);
    private isEmergencyAddressOpen = false;
    public emerShowPhysicianOpt: boolean = false;
    emergencyContactSubscription: Subscription;
    @Input() functionMode: string;
    @Input() displayMode: string;
    @Input() patRes: any;
    @Input() public showPhysicianOpt = false;
    @Input() public toggleEmergencyCont = false;
    @Input() public isNGQCategory;
    @Input() public isICMCategory;
    @Input() public countryCd;
    @Output() public handleEmergencyCont: EventEmitter<any> = new EventEmitter<any>();

    public stringLabels = [
        "label.gb.address_contact",
        "label.gb.emergency_contact",
        "label.gb.address",
        "label.gb.primary_phone",
        "label.gb.phone_country_code",
        "label.gb.phone_area_code",
        "label.gb.phone_number",
        "label.gb.email_addr",
    ]

    public labels: Record<string, string>;

    constructor(
        public dialog: MatDialog,
        public identifierService: IdentifierService,
        private localizationService: LocalizationService,
        private toasterService: ToastrService,
        public deviceDataService: EnrollPatientDeviceDataService,
        public popupService: PopupService,
        public commonService: CommonService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
    }

    ngOnInit() {
        this.translateStrings();
    }

    ngOnChanges(changes: SimpleChanges) {
        if(this.isICMCategory || this.isNGQCategory ||this.isAveirDevice() ) {
            this.emerShowPhysicianOpt = false;
        } else {
            this.emerShowPhysicianOpt = true;
        }
    }

    ngOnDestroy(): void {
        this.emergencyContactSubscription?.unsubscribe();
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    getPhoneInfo(value) {
        if (value) {
            return value.toString().length > 3
                ? value.toString().substring(0, 3) +
                      ' ' +
                      value
                          .toString()
                          .slice(3)
                          .match(/\d{1,4}/g)
                          .join(' ')
                : value;
        }
        return value;
    }
     isAveirDevice(): boolean {
        const productId = this.patRes?.patientDevices?.[0]?.productId;
        if (!productId) return false;
        const code = String(productId);
        return this.aveirLpCodes.has(code);
    }

    onEmergencyContact() {
        this.toasterService.clear();
        this.toggleEmergencyCont = true;
        if (this.displayViewUI()) {
            if (this.toggleEmergencyCont) {
                this.isEmergencyAddressOpen = true;
                this.toggleEmergencyCont = false;
                const dialogRef = this.dialog.open(EmergencyContactPopup, {
                    width: '500px',
                    disableClose: true,
                    data: {
                        mode: FunctionMode.VIEW,
                        showPhysicianOpt: this.showPhysicianOpt,
                        functionMode: this.functionMode,
                        countryCd: this.countryCd,
                        emerShowPhysicianOpt: this.emerShowPhysicianOpt,
                    },
                });
                dialogRef.afterClosed().subscribe((result) => {
                    this.isEmergencyAddressOpen = true;
                    this.toggleEmergencyCont = false;
                    this.handleEmergencyCont.emit({
                        $event: false,
                        isEmerGencyOpen: true,
                    });
                });
            }
        }
    }

    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    getState() {
        if (
            this.patRes?.patient?.address?.stateCd &&
            this.patRes?.dropdowns?.stateCodes
        ) {
            let patChamb = this.patRes.dropdowns.stateCodes.filter((code) => {
                return code.codeId == this.patRes.patient.address.stateCd;
            });
            if (!patChamb) {
                return '';
            } else {
                return this.formatDDString(patChamb[0]);
            }
        } else {
            return this.patRes?.patient?.address?.state;
        }
    }

    getCountry() {
        if (
            this.patRes?.patient?.address?.countryCd &&
            this.patRes?.dropdowns?.countryCodes
        ) {
            let patChamb = this.patRes.dropdowns.countryCodes.filter((code) => {
                return code.codeId == this.patRes.patient.address.countryCd;
            });
            if (!patChamb) {
                return '';
            } else {
                return this.formatDDString(patChamb[0]);
            }
        }
    }

    getZipCode() {
        let zipCodeVal = this.patRes?.patient?.address?.zipCode;
        let countryCd = this.patRes?.patient?.address?.countryCd;
        if (zipCodeVal) {
            if (+countryCd === CountryCdEnum.USA) {
                if (zipCodeVal.length === 9) {
                    zipCodeVal = zipCodeVal?.replace(/(\d{5})(\d{4})/, '$1-$2');
                }
                return zipCodeVal;
            } else {
                return zipCodeVal;
            }
        } else return '';
    }

    formatDDString(ddObj: any) {
        return this.localizationService.generateLocalizedStr(
            'data.Code.' + ddObj.qualifier + '.Code_Desc.' + ddObj.code
        );
    }

    translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key, null, 'html');
    }
}
